import { gql } from "@apollo/client";

// Get all Active Agents by query
export const ACTIVE_AGENTS = gql`
  query GetActiveAgents($searchItem: String!) {
    activeAgents(searchItem: $searchItem) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        id
        name
      }
    }
  }
`;

// Get all Agent Users/ Employees by AgentID
export const ALL_EMPLOYEES_BY_AGENTID = gql`
  query AllEmployeesByAgentId($agent_info_id: UUID!) {
    allEmployeesByAgentId(agent_info_id: $agent_info_id) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        id
        name
        email
        first_name
        last_name
      }
    }
  }
`;

// Get all Currencies by AgentID
export const CURRENCIES_BY_AGENTID = gql`
  query CurrenciesByAgentId($agent_id: UUID!) {
    currenciesByAgentId(agent_id: $agent_id) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData
    }
  }
`;

// Get all Active Agents list (aliased as allActiveAgentsDetails so existing consumers keep working)
export const ACTIVE_AGENTSDETAILS = gql`
  query GetAllActiveAgentsList(
    $searchValues: ActiveAgentDetailsFilterVMInput!
  ) {
    allActiveAgentsDetails: allActiveAgentsList(searchValues: $searchValues) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        address1
        agency_email
        agency_name
        approval_status
        approvedat
        approvedby
        city
        contact_person
        country_code
        email
        fax
        iata_number
        id
        invoice_currency
        is_active
        other_invoice_currencies
        postalcode
        preferred_currency
        previous_number
        region
        telephone
        transactional_email
        website
        billing_location
        api_key
        agent_number
      }
    }
  }
`;

export const ADD_USER_SEARCH_HISTORY_MUTATION = gql`
  mutation GetAddUserSearchHistory(
    $userSearchHistory: UserSearchHistoryVMInput!
  ) {
    addUserSearchHistory(userSearchHistory: $userSearchHistory) {
      successTypeCode
      messageDescription
      responseData {
        check_in_date
        created_by
        created_on
        email
        id
        location
        product_type_name
        purpose_of_travel
        service_date
        user_id
        search_json
      }
    }
  }
`;

export const GET_USER_SEARCH_HISTORY_QUERY = gql`
  query UserSearchHistory(
    $userSearchHistoryFilterVM: UserSearchHistoryFilterVMInput!
  ) {
    userSearchHistory(userSearchHistoryFilterVM: $userSearchHistoryFilterVM) {
      successTypeCode
      messageDescription
      responseData {
        check_in_date
        created_by
        created_on
        email
        id
        hotel_type
        location
        product_type_name
        purpose_of_travel
        service_date
        user_id
        search_json
      }
    }
  }
`;

// Get DMC List by query
export const DMC_QUERY_LIST = gql`
  query ($request: MasterDmcVMFilterInput!) {
    dmcList(dmcVMFilter: $request) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        created_by
        created_on
        description
        id
        is_active
        name
        updated_by
        updated_on
      }
    }
  }
`;

//MasterDmcCitiesVM
/**created_by
created_on
dmcid
featured
id
is_active
updated_by
updated_on
image_url
correlationId
messageCode
totalRecords **/
export const DMC_CITIES_QUERY_LIST = gql`
  query ($request: MasterDmcCitiesFilterVMInput!) {
    masterDmcCities(searchValues: $request) {
      messageDescription
      successTypeCode
      responseData {
        cityname
        count
      }
    }
  }
`;

//MasterDmcTourTypeVM
/** created_by
created_on
dmcid
id
is_active
tourtype
updated_by
updated_on
image_url 
correlationId
messageCode
totalRecords**/
export const DMC_TOURTYPES_QUERY_LIST = gql`
  query ($request: MasterDmcTourTypeFilterVMInput!) {
    masterDmcTourType(searchValues: $request) {      
      messageDescription
      successTypeCode
      responseData {
        tourtype
      }
    }
  }
`;

//DmcListingMergeVM
export const DMC_FEATURED_PACKAGES_QUERY_LIST = gql`
  query ($request: DmcListingMergeFilterVMInput!) {
    dmcListingMerge(searchValues: $request) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        created_by
        created_on
        preferred_currency
        dmcid
        id
        is_active
        value
        updated_by
        updated_on
      }
    }
  }
`;

//DMC packages and details query DMCPackageAndPriceVM
export const DMC_PACKAGES_DETAILS_QUERY_LIST = gql`
  query ($request: DMCPackageAndPriceFilterVMInput!) {
    dmcPackageAndPrice(dmcVMFilter: $request) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        created_by
        created_on
        dmcid
        id
        is_active
        package_json
        preferred_currency
        packagename
        price_json
        priceCreatedBy
        priceCreatedOn
        priceId
        priceIsActive
        priceUpdatedBy
        priceUpdatedOn
        updated_by
        updated_on
      }
    }
  }
`;

export const ZOHO_TICKET_DEPENDENCY_MAPPING = gql`
  query {
    dependencyMappings(layoutId: "169504000000011350") {
      responseData
      successTypeCode
      messageDescription
    }
  }
`;

export const ZOHO_CREATE_TICKET = gql`
mutation ($input: String!, $document: String!, $filename: String!) {
  createTicket(input: $input, document: $document, filename: $filename) {
    responseData
    successTypeCode
    messageDescription
    messageCode
  }
}
`;

export const ZOHO_LAYOUT_RULES = gql`
  query {
    layoutRules(layoutId: "169504000000011350") {
      responseData
      successTypeCode
      totalRecords
      messageDescription
      messageCode
      correlationId
    }
  }
`;
